import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'nom_soc', sortDesc, activeCreditor = true) {
    return Api().post('/front-history/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'active': activeCreditor
    }));
  }
}